import styled from 'styled-components';

const Divider = styled.div<{ noMargin?: boolean }>`
  border-top: 1px solid var(--color-bg-input);
  margin-bottom: ${(props) => (props.noMargin ? 0 : 13)}px;
`;

export default Divider;
